import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorMessage: {
		id: 'navigation-kit-rank-item-service.services.error-message',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Error message informing the user that updating the navigation has failed.',
	},
	errorTitle: {
		id: 'navigation-kit-rank-item-service.services.error-title',
		defaultMessage: "Something's gone wrong",
		description: 'Error title informing the user that updating the navigation has failed.',
	},
	unauthenticatedUserErrorTitle: {
		id: 'navigation-kit-rank-item-service.services.unauthenticated-user-error-title',
		defaultMessage: "You'll need to log in",
		description: 'Error title when the request fails due to the user not being logged in.',
	},
	unauthenticatedUserErrorMessage: {
		id: 'navigation-kit-rank-item-service.services.unauthenticated-user-error-message',
		defaultMessage:
			'You need to be logged in to manage the navigation. Please log in and try again.',
		description: 'Error message when the request fails due to the user not being logged in.',
	},
	authorisationErrorTitle: {
		id: 'navigation-kit-rank-item-service.services.authorisation-error-title',
		defaultMessage: "You don't have permission",
		description: 'Error title when the request fails because user is not allowed.',
	},
	authorisationErrorMessage: {
		id: 'navigation-kit-rank-item-service.services.authorisation-error-message',
		defaultMessage: 'You are not allowed to manage the navigation.',
		description: 'Error message when the request fails because user is not allowed.',
	},
	viewNotFoundErrorTitle: {
		id: 'navigation-kit-rank-item-service.services.view-not-found-error-title',
		defaultMessage: 'This tab has been removed',
		description:
			'Error title when request fails because the view the user is trying to move was not found.',
	},
	viewNotFoundErrorMessage: {
		id: 'navigation-kit-rank-item-service.services.view-not-found-error-message',
		defaultMessage: "The tab you're trying to move can't be found",
		description:
			'Error message when request fails because the view the user is trying to move was not found.',
	},
});
